// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2blfv","rootCenter":"LoadMoreObserver_rootCenter__1nRgg","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3DTRv"};